import React, { useRef, useState } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { projectStatusMap } from '../../../components/ProjectStatusMap';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import 'react-bootstrap-table/dist/react-bootstrap-table.min.css';

import { Col, Row } from 'react-flexbox-grid';
import ShowDeleteMeetingNoteDialog from './DeleteMeetingNoteDialog';
import { projectStatusCodeMap } from '../../../components/ProjectStatusCodeMap';
import { isViewOnlyOrExternalView } from '../../../utils/UserInfo';
import { Dropdown, DropdownButton, Spinner } from 'react-bootstrap';
import { Button, Input, Space, Table, Select, Menu, Checkbox, DatePicker, Empty } from 'antd';
import moment from 'moment';
import { DatePickerAndDropdownComponent, SearchAndDropdownComponent, commonDateSorter, commonFilter, commonSorter, composeFilters } from 'utils/AntdTableFunctions';

const { Option } = Select;

function NotesList(props) {
  const { project, history, meetingNotesList, handleRefreshCall, refresh } = props;
  const [filteredInfo, setFilteredInfo] = useState({});
  const [sortedInfo, setSortedInfo] = useState({});

  function EditViewCellFormatter(cell, row, viewEdit) {
    const status = projectStatusMap[project.projectStatus];
    if (viewEdit === 'Edit')
      history.push(`/${status}/${project.id}/notes/${row.id}`);
    else
      history.push(`/${status}/${project.id}/notes/${row.id}/view`);
  }

  function DeleteCellFormatter(cell, row) {
    ShowDeleteMeetingNoteDialog(project.id, row, handleRefreshCall);
  }

  function ViewCellFormatter(cell, row)
  {
    return (<Link to={`#`} onClick={() => EditViewCellFormatter(cell,row,'View')}><strong>{row.meetingType}</strong></Link>);
  }

  function handleCreate() {
    const projectId = project.id;
    const status = projectStatusMap[project.projectStatus];
    const id = "new";
    history.push(`/${status}/${projectId}/notes/${id}`);
  }

  function composeCustomFilters(fieldName) {
    let filters = [...new Set(meetingNotesList.map(note => note[fieldName] || '[BLANK]'))];
    let filtersSort = filters.map(distinctFilters => ({ label: distinctFilters, value: distinctFilters }));
    filtersSort.sort((a, b) => {
      a = a.label || '';
      b = b.label || '';
      return a.toLowerCase().localeCompare(b.toLowerCase());
    });

    return filtersSort;
  }
  const handleChange = (pagination, filters, sorter) => {
    setFilteredInfo(filters);
    setSortedInfo(sorter);
  };

  const columns = [
    {
      dataIndex: 'id',
      key: 'id',
      title: 'Action',
      hidden:  isViewOnlyOrExternalView() || project.projectStatus == projectStatusCodeMap['CLOSED'],
      render: (cell, row) => (
          <DropdownButton id={`${row.id}-dropdown`} title='' style={{width: '100%'}} >
            <Dropdown.Item onClick={() => EditViewCellFormatter(cell, row, 'Edit')}>Edit</Dropdown.Item>
            <Dropdown.Item onClick={() => DeleteCellFormatter(cell, row)}>Delete</Dropdown.Item>
          </DropdownButton>
      ),
      style: { textAlign: 'center' },
      headerStyle: { textAlign: 'center' }
    }, {
      dataIndex: 'meetingType',
      key: 'meetingType',
      title: 'Meeting Type',
      render: ViewCellFormatter,
      width: '15%',
      style: { textAlign: 'left', verticalAlign: 'middle' },
      filters: composeFilters('meetingType',meetingNotesList),
      onFilter: (value,record)=>commonFilter(value,record,'meetingType'),
      sorter: (a, b) => commonSorter(a,b,'meetingType'),
    }, {
      dataIndex: 'meetingDate',
      key: 'meetingDate',
      title: 'Meeting Date',
      width: '15%',
      style: { verticalAlign: 'middle' },
      filters: composeCustomFilters('meetingDate'),
      ...DatePickerAndDropdownComponent(),
      onFilter: (value, record) => {
        if (Array.isArray(value)) {
          return (value.includes(record.meetingDate))
        } else {
          return (record.meetingDate.toLowerCase().includes(value.toLowerCase()) || (value.includes(`${record.meetingDate}`)))
        }
      },
      sorter: (a, b) => commonDateSorter(a, b, 'meetingDate'),
      defaultSortOrder: 'ascend'
    }, {
      dataIndex: 'meetingLocation',
      key: 'meetingLocation',
      title: 'Meeting Location',
      width: '20%',
      style: { textAlign: 'left', verticalAlign: 'middle' },
      headerStyle: {
        textAlign: 'left'
      },
      filters: composeCustomFilters('meetingLocation'),
      ...SearchAndDropdownComponent(),
      onFilter: (value, record) => {
        if (Array.isArray(value)) {
          return (value.includes(record.meetingLocation))
        } else {
          return (record.meetingLocation.toLowerCase().includes(value.toLowerCase()) || (value.includes(`${record.meetingLocation}`)))
        }
      },
      sorter: (a, b) => {
        a = a.meetingLocation || '';
        b = b.meetingLocation || '';
        return a.toLowerCase().localeCompare(b.toLowerCase());
      },
    }, {
      dataIndex: 'createdUserName',
      key: 'createdUserName',
      title: 'Created By',
      width: '20%',
      style: { textAlign: 'left', verticalAlign: 'middle' },
      headerStyle: {
        textAlign: 'left'
      }
    }, {
      dataIndex: 'modifiedUserName',
      key: 'modifiedUserName',
      title: 'Last Modified By',
      width: '20%',
      style: { textAlign: 'left', verticalAlign: 'middle' },
      headerStyle: {
        textAlign: 'left'
      }
    }
  ];


  return (
    <>
      {project.projectStatus !== projectStatusCodeMap["CLOSED"] && !isViewOnlyOrExternalView() &&
        <Row className='justify-content-end'>
          <Col style={{ paddingBottom: 8 }}>
            <button type="button" className="btn btn-primary" onClick={handleCreate}>CREATE NEW MEETING NOTE</button>
          </Col>
        </Row>
      }
      <Row>
        <div className='table-responsive antd-table-custom-css' style={{ overflow: 'hidden'  }}>
          <Table
            className={'table-striped'}
            keyField='id'
            bordered
            dataSource={meetingNotesList}
            columns={columns}
            pagination={{ showSizeChanger: false, pageSize: 10 }}
            locale={{ emptyText: (refresh?(<Empty description={(<h6>Loading</h6>)} />):<Empty description={(<h6>No Meeting Notes Found</h6>)} />) }}
            loading={refresh}
            filter={filterFactory()}
            onChange={handleChange}
          />
        </div>
      </Row>
    </>
  );
}

export default withRouter(NotesList);
